/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban_funnels', { accountScoped: true });
  }

  // Funis
  getFunnels() {
    return this.get();
  }

  createFunnel(funnelData) {
    return this.create(funnelData);
  }

  updateFunnel(funnelId, funnelData) {
    return this.update(funnelId, funnelData);
  }

  deleteFunnel(funnelId) {
    return this.delete(funnelId);
  }

  // Cards
  getCards(funnelId, params = {}) {
    return axios.get(`${this.url}/${funnelId}/cards`, { params });
  }

  // Obtém detalhes agregados de uma coluna (etiqueta) para um funil
  getColumnDetails(
    funnelId,
    labelId,
    cardTypes = ['conversation', 'contact', 'company'],
    search = '',
    assigneeId = '',
    teamId = ''
  ) {
    const params = { label_id: labelId, card_types: cardTypes, search };
    if (assigneeId !== '' && assigneeId !== null && assigneeId !== undefined) {
      params.assignee_id = assigneeId;
    }
    if (teamId !== '' && teamId !== null && teamId !== undefined) {
      params.team_id = teamId;
    }
    return axios.get(`${this.url}/${funnelId}/column_details`, { params });
  }

  // Atualiza as labels de uma conversa pelo Kanban
  updateConversationLabelsByKanban(conversationId, oldLabel, newLabel) {
    return axios.put(
      `${this.baseUrl()}/conversations/${conversationId}/update_labels_by_kanban`,
      {
        old_label: oldLabel,
        new_label: newLabel,
      }
    );
  }

  // Atualiza as labels de um contato pelo Kanban
  updateContactLabelsByKanban(contactId, oldLabel, newLabel) {
    // Garante que contactId seja um número
    const parsedContactId = parseInt(contactId, 10);

    if (isNaN(parsedContactId)) {
      return Promise.reject(new Error('ID de contato inválido'));
    }

    return axios.put(
      `${this.baseUrl()}/contacts/${parsedContactId}/update_labels_by_kanban`,
      {
        old_label: oldLabel,
        new_label: newLabel,
      }
    );
  }

  // Busca detalhes atualizados de um contato (para atualizar o card após mudanças)
  getContactDetails(contactId) {
    const parsedContactId = parseInt(contactId, 10);

    if (isNaN(parsedContactId)) {
      return Promise.reject(new Error('ID de contato inválido'));
    }

    return axios.get(`${this.baseUrl()}/contacts/${parsedContactId}`);
  }

  // Busca detalhes atualizados de uma conversa (para atualizar o card após mudanças)
  getConversationDetails(conversationId) {
    return axios.get(`${this.baseUrl()}/conversations/${conversationId}`);
  }
}

export default new KanbanAPI();
